import { render, staticRenderFns } from "./EditGas.vue?vue&type=template&id=28d16b0e&"
import script from "./EditGas.vue?vue&type=script&lang=js&"
export * from "./EditGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports